import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ideabaazLogo from '../../../../Assets/images/ideabaaz.svg';
import { useStyles } from './styles'; // Keep if you still need theme-colored classes

const ENABLE_CLAMP = true; // set false if you don't want text truncation

const InitiativeSection = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Box
      className={classes.section}
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        px: { xs: 1, md: 4 },
        pr: { xs: 1, md: 8 },
        py: { xs: 8, md: 10 },
        overflow: 'hidden',
      }}
    >
      <Box
        className={classes.cardsContainer}
        sx={{
          display: 'flex',
          /* stack until lg, then row with 60/40 */
          flexDirection: { xs: 'column', lg: 'row' },
          gap: { xs: 3, md: 4 },
          width: '82.5%',
        }}
      >
        {/* Card 1 */}
        <Box
          sx={{
            width: { xs: '100%', lg: '60%' },
            flex: { lg: '0 0 60%' },
            display: 'flex',
          }}
        >
          <Box
            className={classes.cardOrange}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              p: { xs: 2.5, md: 3 },
              boxSizing: 'border-box',
              /* Height control */
              maxHeight: { xs: 300, md: 380 },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Header Row */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: 2,
              }}
            >
              <Typography
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 600,
                  lineHeight: 1.25,
                  fontSize: { xs: '1.4rem', md: '1.55rem' },
                  flexGrow: 1,
                  minWidth: 0,
                }}
              >
                Building a startup?
              </Typography>
              <Box
                component="img"
                src={ideabaazLogo}
                alt="Ideabaaz"
                loading="lazy"
                className={classes.logoTopRight}
                sx={{
                  height: { xs: 36, md: 42 },
                  width: 'auto',
                  flexShrink: 0,
                }}
              />
            </Box>

            {/* Body Text */}
            <Typography
              className={classes.cardText}
              sx={{
                fontSize: { xs: 14, md: 15 },
                lineHeight: 1.45,
                color: 'inherit',
                ...(ENABLE_CLAMP && {
                  display: '-webkit-box',
                  WebkitLineClamp: { xs: 6, md: 5 },
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }),
                flexShrink: 1,
                minHeight: 0,
              }}
            >
              Ideabaaz is a founder-first, Bharat-wide platform for everyday startups solving today's real-world problems. If you're building a growth startup in logistics, fintech, health, edtech, or
              consumer SaaS, this is your moment.
            </Typography>

            {/* CTA Button */}
            <Button
              className={classes.ctaBtn}
              variant="contained"
              onClick={() => navigate('/signup?applicationName=ideaBaaz')}
              sx={{
                alignSelf: 'flex-start',
                mt: 'auto',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 2.5,
                py: 1,
                fontSize: 14,
                lineHeight: 1.2,
                borderRadius: 2,
                maxWidth: '100%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              <span>Register your startup</span>

              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path
                  d="M4.75 4.42578C4.05964 4.42578 3.5 4.98543 3.5 5.67578V12.1758C3.5 12.8661 4.05964 13.4258 4.75 13.4258H11.25C11.9404 13.4258 12.5 12.8661 12.5 12.1758V10.6758C12.5 10.2616 12.8358 9.92578 13.25 9.92578C13.6642 9.92578 14 10.2616 14 10.6758V12.1758C14 13.6946 12.7688 14.9258 11.25 14.9258H4.75C3.23122 14.9258 2 13.6946 2 12.1758V5.67578C2 4.157 3.23122 2.92578 4.75 2.92578H6.25C6.66421 2.92578 7 3.26157 7 3.67578C7 4.08999 6.66421 4.42578 6.25 4.42578H4.75ZM7.99976 3.67578C7.99976 3.26157 8.33554 2.92578 8.74976 2.92578H13.2498C13.664 2.92578 13.9998 3.26157 13.9998 3.67578V8.17578C13.9998 8.58999 13.664 8.92578 13.2498 8.92578C12.8355 8.92578 12.4998 8.58999 12.4998 8.17578V5.48673L9.28008 8.70634C8.98719 8.99924 8.51231 8.99923 8.21942 8.70634C7.92653 8.41344 7.92653 7.93857 8.21943 7.64568L11.4394 4.42578H8.74976C8.33554 4.42578 7.99976 4.08999 7.99976 3.67578Z"
                  fill="white"
                />
              </svg>
            </Button>
          </Box>
        </Box>

        {/* Card 2 */}
        <Box
          sx={{
            width: { xs: '100%', lg: '40%' },
            flex: { lg: '0 0 40%' },
            display: 'flex',
            mr: { lg: '200px' },
          }}
        >
          <Box
            className={classes.cardBlack}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              p: { xs: 2.5, md: 5 },
              boxSizing: 'border-box',
              maxHeight: { xs: 300, md: 380 },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 600,
                lineHeight: 1.25,
                fontSize: { xs: '1.35rem', md: '1.5rem' },
                pr: 1,
              }}
            >
              Idea on your mind?
            </Typography>

            <Typography
              className={classes.cardText}
              sx={{
                fontSize: { xs: 14, md: 15 },
                lineHeight: 1.45,
                ...(ENABLE_CLAMP && {
                  display: '-webkit-box',
                  WebkitLineClamp: { xs: 6, md: 5 },
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }),
                flexShrink: 1,
                minHeight: 0,
              }}
            >
              Some of the most powerful ideas start as fleeting conversations in unlikely places. Dangal is a space for bold thinkers with early sparks. All you need is a powerful idea and the courage
              to share it.
            </Typography>

            <Button
              className={classes.ctaBtn}
              variant="contained"
              onClick={() => window.open('https://www.ideabaazdangal.com/register', '_blank', 'noopener')}
              sx={{
                mt: 'auto',
                alignSelf: 'flex-start',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 2.5,
                py: 1,
                fontSize: 14,
                fontWeight: 400,
                lineHeight: 1.2,
                borderRadius: 2,
                maxWidth: '100%',
                background: 'rgba(255,255,255,1) !important',
                color: '#E1490B !important',
                border: '1px solid #B73601 !important',
                boxShadow: '0px 1px 2px 0px rgba(183,54,1,0.3), 0px 0px 0px 2px rgba(183,54,1,0.16) !important',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.9) !important',
                  background: 'rgba(255,255,255,0.9) !important',
                },
              }}
            >
              <span>Register your idea</span>
              <Box component="span" sx={{ lineHeight: 0, display: 'flex' }}>
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path
                    d="M4.75 4.42578C4.05964 4.42578 3.5 4.98543 3.5 5.67578V12.1758C3.5 12.8661 4.05964 13.4258 4.75 13.4258H11.25C11.9404 13.4258 12.5 12.8661 12.5 12.1758V10.6758C12.5 10.2616 12.8358 9.92578 13.25 9.92578C13.6642 9.92578 14 10.2616 14 10.6758V12.1758C14 13.6946 12.7688 14.9258 11.25 14.9258H4.75C3.23122 14.9258 2 13.6946 2 12.1758V5.67578C2 4.157 3.23122 2.92578 4.75 2.92578H6.25C6.66421 2.92578 7 3.26157 7 3.67578C7 4.08999 6.66421 4.42578 6.25 4.42578H4.75ZM7.99976 3.67578C7.99976 3.26157 8.33554 2.92578 8.74976 2.92578H13.2498C13.664 2.92578 13.9998 3.26157 13.9998 3.67578V8.17578C13.9998 8.58999 13.664 8.92578 13.2498 8.92578C12.8355 8.92578 12.4998 8.58999 12.4998 8.17578V5.48673L9.28008 8.70634C8.98719 8.99924 8.51231 8.99923 8.21942 8.70634C7.92653 8.41344 7.92653 7.93857 8.21943 7.64568L11.4394 4.42578H8.74976C8.33554 4.42578 7.99976 4.08999 7.99976 3.67578Z"
                    fill="#B73601"
                  />
                </svg>
              </Box>
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default InitiativeSection;
